module.exports = __webpack_public_path__ + "img/pic-1.6c0cb3b9.png";